export function interviewToFormData(agencyInterview, agentInterview) {
    const answer = questionType => agencyInterview?.questionAnswers?.[questionType]?.answer;
    const agentAnswer = questionType => agentInterview?.questionAnswers?.[questionType]?.answer;

    const getIndividualName = () => {
        if (answer("EntityName")) {
            return answer("EntityName");
        }
        if (answer("W9RegistrationAsIndividual") === "true" && agentAnswer("FirstName") && agentAnswer("LastName")) {
            return `${agentAnswer("FirstName")} ${agentAnswer("LastName")}`;
        }
        if (answer("W9RegistrationAsIndividual") === "false" && answer("AgencyName")) {
            return answer("AgencyName");
        }
        return undefined;
    };

    return {
        individualName: getIndividualName(),
        businessName: answer("BusinessDisregardedEntityName"),
        llcType: answer("LlcType"),
        payeeName: answer("PayeeName"),
        taxClassification: answer("FederalTaxClassification"),
        otherTaxClass: answer("OtherTaxClassification"),
        exemptCode: answer("ExemptPayeeCode"),
        fatcaCode: answer("ExemptionFromFatcaReportingCode"),
        addressLine1: answer("W9AddressStreetLineOne"),
        addressLine2: answer("W9AddressStreetLineTwo"),
        city: answer("W9AddressCity"),
        state: answer("W9AddressState"),
        zipCode: answer("W9AddressZipCode"),
        w9AddressSameAsAgencyPrimaryPhysical: answer("W9AddressSameAsAgencyPrimaryPhysical") === "true",
        w9AddressSameAsAgencyPrimaryMailing: answer("W9AddressSameAsAgencyPrimaryMailing") === "true",
        accountNumbers: answer("OptionalAccountNumbers"),
        ssn: answer("Ssn"),
        fein: answer("Fein")
    };
}

export function formDataToQuestionAnswers(formData) {
    const mapIfExists = (key, value) => value !== null && value !== undefined ? { [key]: { answer: value } } : {};

    return {
        ...mapIfExists("EntityName", formData.individualName),
        ...mapIfExists("BusinessDisregardedEntityName", formData.businessName),
        ...mapIfExists("LlcType", formData.llcType),
        ...mapIfExists("PayeeName", formData.payeeName),
        ...mapIfExists("FederalTaxClassification", formData.taxClassification),
        ...mapIfExists("OtherTaxClassification", formData.otherTaxClass),
        ...mapIfExists("ExemptPayeeCode", formData.exemptCode),
        ...mapIfExists("ExemptionFromFatcaReportingCode", formData.fatcaCode),
        ...mapIfExists("W9AddressStreetLineOne", formData.addressLine1),
        ...mapIfExists("W9AddressStreetLineTwo", formData.addressLine2),
        ...mapIfExists("W9AddressCity", formData.city),
        ...mapIfExists("W9AddressState", formData.state),
        ...mapIfExists("W9AddressZipCode", formData.zipCode),
        ...mapIfExists("W9AddressCountry", "US"),
        ...mapIfExists("W9AddressSameAsAgencyPrimaryPhysical", formData.w9AddressSameAsAgencyPrimaryPhysical?.toString()),
        ...mapIfExists("W9AddressSameAsAgencyPrimaryMailing", formData.w9AddressSameAsAgencyPrimaryMailing?.toString()),
        ...mapIfExists("OptionalAccountNumbers", formData.accountNumbers),
        ...mapIfExists("Ssn", formData.ssn),
        ...mapIfExists("Fein", formData.fein)
    };
}